export default import.meta.ROLLDOWN_FILE_URL_$Uz2JHrPn9gid3VmLp8wGA